export interface IDataComplianceEntityGroup {
    entityId: number | null,
    displayName: string,
    category: number | null,
    issues: string[]
}

export interface IDataComplianceIssues {
    logDate: string,
    overallChecked: number,
    overallFailed: number,
    overallPercent: number,
    centerIssues: string[],
    donors: IDataComplianceEntityGroup[],
    recipients: IDataComplianceEntityGroup[],
    dashRemoteStatus: IDataComplianceEntityGroup[],
    microsite: IDataComplianceEntityGroup[]
}
